'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _sync = require('./sync.xhr');

var _sync2 = _interopRequireDefault(_sync);

var _sync3 = require('./sync.listener');

var _sync4 = _interopRequireDefault(_sync3);

var _sync5 = require('./sync.websocket');

var _sync6 = _interopRequireDefault(_sync5);

var _sync7 = require('./sync.ddos');

var _sync8 = _interopRequireDefault(_sync7);

var _sync9 = require('./sync.polling');

var _sync10 = _interopRequireDefault(_sync9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Sync = function () {
    function Sync(id) {
        _classCallCheck(this, Sync);

        this.id = id;

        return this;
    }

    _createClass(Sync, [{
        key: 'getEngine',
        value: function getEngine() {
            return Sync._getEngine(this.id);
        }
    }], [{
        key: 'getEngine',
        value: function getEngine(id) {
            return Sync._getEngine(id);
        }
    }, {
        key: '_getEngine',
        value: function _getEngine(id) {
            var Engine = void 0;

            switch (id) {
                case 'ddos':
                    Engine = _sync8.default;
                    break;
                case 'listener':
                    Engine = _sync4.default;
                    break;
                case 'webSocket':
                    Engine = _sync6.default;
                    break;
                case 'polling':
                    Engine = _sync10.default;
                    break;
                default:
                    Engine = _sync2.default;
                    break;
            }

            return Engine;
        }

        /**
         * @return {function} singleton of this class
         */

    }, {
        key: 'getInstance',
        value: function getInstance() {
            if (!this.prototype.singletonInstance) {
                var parent = this,
                    Surrogate = void 0;

                Surrogate = function Surrogate() {
                    var _parent$prototype$con;

                    for (var _len2 = arguments.length, rest = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                        rest[_key2] = arguments[_key2];
                    }

                    // для того что бы принимать динамическое к-во аргументов в конструктор
                    return (_parent$prototype$con = parent.prototype.constructor).call.apply(_parent$prototype$con, [this].concat(rest));
                };

                Surrogate.prototype = parent.prototype;

                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                this.prototype.singletonInstance = new (Function.prototype.bind.apply(Surrogate, [null].concat(args)))();
            }

            return this.prototype.singletonInstance;
        }
    }]);

    return Sync;
}();

exports.default = Sync;